export const putItemsInCategories = (menuItems, menuAndCategories) => {
    // Loop through all menu items
    menuItems.forEach(item => {
        const { menuName, itemCategory, itemSubCategory } = item;

        // Find the corresponding menu group (e.g., "Lunch Specials" or "Dinner")
        const menuGroup = menuAndCategories[menuName];
        if (!menuGroup) return;

        // Find the correct category object within that menu
        const categoryObj = menuGroup.find(cat => cat.category === itemCategory);
        if (!categoryObj) return;

        if (itemSubCategory) {
            // If the item has a subcategory, find that subcategory object
            const subCatObj = categoryObj.subcategories?.find(
                sub => sub.subCategoryName === itemSubCategory
            );

            // If subcategory object exists, push item into its items array
            if (subCatObj) {
                if (!subCatObj.items) subCatObj.items = [];
                subCatObj.items.push(item);
            }
        } else {
            // If no subcategory, push into category's main items array
            if (!categoryObj.items) categoryObj.items = [];
            categoryObj.items.push(item);
        }
    });

    return menuAndCategories;
};
